import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SmartRtpLayout from "./components/SmartRtpLayout";
import SmartRtpCards from "./components/SmartRtpCards";
import { getDashboardSummary } from "../../../controllers/V1/smartRtp/smartRtpController";
import { SMART_RTP_TABS } from "./config";

export default function SmartRtpDashboard() {
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const loadSummary = async () => {
    setLoading(true);
    const res = await getDashboardSummary({});
    if (res.status === true) {
      setSummary(res.result?.metrics || res.result || {});
    }
    setLoading(false);
  };

  useEffect(() => {
    document.title = "Crown King || Smart RTP Dashboard";
    loadSummary();
  }, []);

  const cards = [
    { key: "orders", label: "Total Orders", value: summary.total_orders || 0 },
    { key: "tickets", label: "Total Tickets", value: summary.total_tickets || 0 },
    { key: "stake", label: "Total Stake", value: summary.total_stake || 0 },
    { key: "rewards", label: "RTP Rewards", value: summary.total_rewards || 0, helper: "Excludes scheduled big prizes" },
    { key: "wins", label: "Win Orders", value: summary.win_orders || 0 },
    { key: "rtp", label: "Actual RTP %", value: summary.actual_rtp || 0, helper: "Excludes Big Prize & Time Slot" },
    {
      key: "scheduled-bp",
      label: "Scheduled Big Prizes",
      value: summary.scheduled_big_prize_count || 0,
      helper: "Time Slot awards · not in RTP",
    },
    {
      key: "scheduled-bp-amt",
      label: "Scheduled BP Amount",
      value: summary.scheduled_big_prize_amount || 0,
      helper: "Office claim · pool not debited",
    },
    { key: "buyers", label: "Unique Buyers", value: summary.unique_buyers || 0 },
    { key: "pos", label: "Unique POS", value: summary.unique_pos || 0 },
  ];

  return (
    <SmartRtpLayout
      title="Smart RTP Dashboard"
      activeKey="dashboard"
      headerVariant="module"
      onRefresh={loadSummary}
    >
      <SmartRtpCards cards={cards} />
      <div className="row">
        {SMART_RTP_TABS.filter((item) => item.key !== "dashboard").map((item) => (
          <div className="col-md-4 mb-3" key={item.key}>
            <div className="card shadow h-100">
              <div className="card-body">
                <div className="text-uppercase small text-muted mb-2">{item.label}</div>
                <p className="mb-3">
                  Smart RTP {item.label.toLowerCase()} module powered by isolated admin
                  APIs.
                </p>
                <Link to={item.path}>Open {item.label}</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
      {loading ? <div className="small text-muted mt-2">Refreshing dashboard...</div> : null}
    </SmartRtpLayout>
  );
}
